import { render } from "./AllPosts.vue?vue&type=template&id=688d6229"
import script from "./AllPosts.vue?vue&type=script&lang=js"
export * from "./AllPosts.vue?vue&type=script&lang=js"

import "./AllPosts.vue?vue&type=style&index=0&id=688d6229&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__